<template>
	<div class="root">
		<rdMeetingHearder active='personal'/>
		<div class="container">
			<!-- <div class="tips">
				<p style="margin-top: 10px;"><span style="color:#B176C5;">限时取消：</span>截止预约日期三日前24点，可自主免费取消预约；超时限后不再接受取消，如未出席仍视为占用。</p>
				<p style="margin-top: 10px;"><span style="color:#B176C5;">注意事项：</span>如取消，该笔预约订单内所有预约时间段将一并取消，不支持部分取消。</p>
				<p style="margin-top: 10px;"><span style="color:#B176C5;">收费方式：</span>先预约使用，次月服务费税前结算抵扣</p>
			</div> -->
			<div class="searchbar">
				<DatePicker size='large' v-model='beginTime' class='datepicker' type="date" placeholder="选择日期"></DatePicker>
				<div class="division">至</div>
				<DatePicker size='large' v-model='endiTime' class='datepicker' type="date" placeholder="选择日期"></DatePicker>
				<Button size='large' class='button' type='primary' @click='search' :loading='loading'>搜索</Button>
			</div>
			<Tabs v-model="roomStatus">
				<TabPane label="全部" name="all"></TabPane>
				<TabPane label="已预约" name="pay"></TabPane>
		        <TabPane label="已使用" name="used"></TabPane>
		        <!-- <TabPane label="已确认" name="complete"></TabPane> -->
		        <TabPane label="已取消" name="cancel"></TabPane>
		    </Tabs>
		    <div class='load' v-if='loading'>
				<loading />
			</div>
		    <template v-else-if='showOrders.length'>
		    	<div class="order" v-for='order in showOrders'>
					<div class="header">
						<div class="orderno">预约号：{{order.OrderNo}}</div>
						<div class="status">{{getOrderStatusStr(order.OrderStatus)}}</div>
					</div>
					<div class="order-detail">
						<div class="room-img">
							<img :src="order.RoomImage" alt="">
						</div>
						<div class="rooms">
							<div class="desc" v-if='order.detail && order.detail[0]'>
								<div class="room-item" v-for='detail in order.detail'>
									<div class="room-name">{{detail.RoomName}}</div>
									<div class="room-name" v-if="detail.ProductName">预约课程：{{detail.ProductName}}</div>
								</div>
								<div v-for='detail in order.detail' v-if='detail.IsRoom'>
									<div class="room-item">
										<div class="time">
											<div class="timerange">预约日期：{{detail.BookingDate}} <span v-if='detail.BeginTime'>{{detail.BeginTime}} - {{detail.EndTime}}</span></div>
										</div>
									</div>
									<div class="room-item">
										<div class="room-name">预约人数：{{detail.Qty}}</div>
									</div>
								</div>
								<div class='order-user'>
									<span>参观团长：</span>
									<span class="user">{{order.detail[0].BookUserName}}</span>
									<span class="user">{{order.detail[0].Description}}</span>
									<span class="user">{{order.detail[0].MobilePhone}}<span style="color: grey;text-decoration: underline;cursor: pointer;" @click="change(order)" v-if="order.OrderStatus.toLowerCase() == 'pay'">修改</span></span>
								</div>
							</div>
							<!-- <div class="room-item" v-for='detail in order.detail'>
								<div class="room-name">{{detail.RoomName || detail.ProductName}}<span v-if='!detail.IsRoom'>&nbsp;×&nbsp;{{detail.Qty}}</span></div>
								<div class="time" v-if='detail.IsRoom'>
									<div class="timerange">{{detail.BookingDate}} <span v-if='detail.BeginTime'>{{detail.BeginTime}} - {{detail.EndTime}}</span></div>
								</div>
								<div class="price">￥{{detail.Price * (detail.Qty || 1)}}</div>
							</div> -->
						</div>
						<div class='detail-right'>
							<!-- <div class="amount">总计：￥{{order.Amount}}</div> -->
							<div class="buttons">
								<div class="cancel" @click='tipShow = true'>注意事项</div>
								<div class="cancel" @click='cancelOrder(order)' v-if="order.OrderStatus.toLowerCase() == 'pay'">取消</div>
							</div>
						</div>
					</div>
				</div>
		    </template>
		    <div v-else class='nodata'>
		    	暂无数据
		    </div>
		</div>
	    <Modal v-model="tipShow" width="500" :footer-hide="true" :styles="{top: '200px'}">
        	<div class="modal">
				<div class="title">注意事项</div>
				<div class="content">
					<div>1. 参观前三天多特瑞将与您联系，沟通参观事项。</div>
					<div>2. 团员凭预约码进入，乘坐电梯至三楼共享区等候。</div>
					<div>3. 团长负责集合并清点团员人数，保证参观活动准时开始。</div>
					<div>4. 参观流程</div>
					<div>1）工作人员引导参观</div>
					<div>2）培训课程及互动</div>
					<br>
					<div>*参观者需在16:30前全部离场。</div>
				</div>
        	</div>
	    </Modal>
	    <Modal v-model="changephone" title="修改手机号" width="500" :styles="{top: '200px'}">
        	<div class="modal">
				<Input v-model='BookUserMobilePhone' placeholder="请输入手机号" @on-blur="checkmobile"></Input>
				<div class="error" v-if="error.errormoblie">{{error.errormoblie}}</div>
        	</div>
			<div slot="footer" class="footer">
				<div class="cancel" @click="changephone = false">取消</div>
				<div class="confirm" @click="changemobilephone">确定</div>
			</div>
	    </Modal>
	</div>
</template>
<script>
import { mapState,mapMutations,mapActions,mapGetters } from 'vuex'
import rdMeetingHearder from '@/components/header/rdMeetingHearder'
import loading from "@/components/order/loading";
import util from '@/config/util'
import {RE_PHONE} from '@/components/common/regex';
import { cvoUrl } from "@/config/env";
const now = util.realNowTime();
export default {
	data() {
		return {
			beginTime: new Date(now.getFullYear(),now.getMonth(),1),
			endiTime: new Date(now.getFullYear(),now.getMonth()+2,0),
			orders: [],
			loading: false,
			roomStatus: 'all',
			tipShow: false,
			changephone: false,
			changeorder: '',
			BookUserMobilePhone: '',
            error: {
                errormoblie: '',
            },
		}
	},
	created() {
		this.$nextTick(function() {
			this.initData();
		})
	},
	mounted() {
	},
	watch:{
	},
	mixins:[],
	components: {
		rdMeetingHearder,
		loading,
	},
	computed: {
		...mapState({
		}),
		...mapGetters(["getAccessToken"]),
		showOrders(){
			if (this.roomStatus == 'all') return this.orders;
			if(this.roomStatus == 'used'){
				return this.orders.filter(item=>item.OrderStatus.toLowerCase() == 'used' || item.OrderStatus.toLowerCase() == 'complete');
			}else{
				return this.orders.filter(item=>item.OrderStatus.toLowerCase() == this.roomStatus);
			}
		}
	},
	methods: {
		...mapActions([
			'checkRDPermissionsctionAction','getRDMeetingRoomsAction','getReservationOrdersAction','postCancelReservationAction','postChangeMobileAction',
		]),
		async initData(){
			this.loading = true;
            // 判断白名单权限
            let res = await this.checkRDPermissionsctionAction()
            let response = await this.getRDMeetingRoomsAction();
            console.log(response);
            if(!res || !response || !response?.Table1?.length){
                this.$Modal.warning({
                    title:'提示',
                    content:'您没有申请会议室的权限',
                    onOk:()=>{
				        location = `${cvoUrl}/vo/index.html#/home?token=${this.getAccessToken}`;
                    }
                })
                return
            }
			this.search();
		},
		getOrderStatusStr(status){
			const statusStr = {
				unpay:'未确认',
				cancel:'已取消',
				pay:'已预约',
				complete:'已确认',
				used:'已使用'
			}
			return statusStr[status.toLowerCase()];
		},
		async search(){
			this.loading = true;
			let response = await this.getReservationOrdersAction({
				BeginTime: util.formatDate.format(this.beginTime,'yyyy-MM-dd'),
				EndTime: util.formatDate.format(this.endiTime,'yyyy-MM-dd'),
				BookType: 1,
			})
			let ordersMap = {};
			response.forEach(item=>{
				if (ordersMap[item.ID]) {
					ordersMap[item.ID].detail.push(item);
				} else {
					ordersMap[item.ID] = item;
					ordersMap[item.ID].detail = [item];
				}
			});
			let orders = Object.values(ordersMap);
			orders.sort((a,b)=>{return b.ID - a.ID});
			this.orders = orders;
			console.log(orders);
			this.loading = false;
		},
		change(order){
			this.changephone = true;
			this.changeorder = order;
		},
        checkmobile(){
            if (!this.BookUserMobilePhone) {
                this.error.errormoblie = '请填写手机号码';
                return false;
            }else if (!RE_PHONE.test(this.BookUserMobilePhone)) {
                this.error.errormoblie = '请填写正确的手机号码';
                return false;
            }else{
                this.error.errormoblie = '';
                return true;
            }
        },
		async changemobilephone(){
            if(!this.checkmobile()) return;
			let params = {
				BookingId: this.changeorder.ID,
				BookUserName: this.changeorder.BookUserName,
				BookUserMobilePhone: this.BookUserMobilePhone,
				BookUserVipNo: this.changeorder.Description,
			}
			let res = await this.postChangeMobileAction(params);
			if(res.Value > 0){
                this.$Message.success('修改成功');
				this.changephone = false;
				this.BookUserMobilePhone = '';
				this.initData();
			}
		},
		async cancelOrder(order){
			let date = new Date(order.BookingDate)
			let limitDate = new Date(date.getFullYear(),date.getMonth()-1,27);
			if (new Date(now) <= limitDate) {
				this.$Modal.confirm({
					title: '确定要取消预约吗?',
					content: '温馨提示：如取消该预约，订单内所有预约内容，包括课程将一并取消！',
					loading: true,
					onOk:async ()=>{
						let response = await this.postCancelReservationAction({
							BookingId: order.ID,
						})
						this.$Modal.remove();
						setTimeout(()=>{
							if (typeof response.Value == 'string') {
								this.$Modal.info({
									title:'提示',
									content:response.Value,
								})
								this.initData();
							}
						}, 300);
					}
				})
			}else if(new Date(now) > limitDate){
				this.$Modal.info({
					width: 550,
					title: '抱歉，您已超过取消时限，无法取消该预约！',
					content: '温馨提示：如未出席，仍视为占用。',
				})
			}
		}
	},
}
</script>
<style lang='scss' scoped>
@import '@/style/mixin';
.root {
	display:block;
	background-color: #eee;
}
.container {
	max-width: 1400px;
	padding-top: 0.85rem;
	margin: auto;
}
.searchbar {
	display:flex;
	align-items: center;
	justify-content: center;
	margin-top: 20px;
	margin-bottom: 30px;
	.datepicker {
		width: 200px;
		border-radius: 60px;
		box-shadow: 3px 8px 20px 0px rgba(0,0,0,0.1);
	}
	.division {
		margin: 0 20px;
	}
	.button {
		width:150px;
		margin-left: 20px;
		border-radius: 20px;
	}
}
.order {
	margin-bottom: 20px;
	.header {
		background-color: #BD8BCA;
		color:white;
		display:flex;
		justify-content: space-between;
		padding:20px;
		@include fontSize($font-size-18);
		border-top-left-radius: 20px;
		border-top-right-radius: 20px;
	}
	.order-detail {
		background-color:white;
		display:flex;
		align-items: center;
		padding:20px;
		.room-img {
			width:150px;
			height:150px;
			img {
				border-radius: 20px;
				width:100%;
				height:100%;
				object-fit: cover;
			}
		}
		.rooms {
			flex:1;
			padding-left: 20px;
			@include fontSize($font-size-16);
			.desc {
				.store {
					margin-bottom: 10px;
				}
				.order-user {
					margin-bottom: 5px;
					.user {
						padding-right: 20px;
					}
				}
				.remark {
					margin-bottom: 10px;
				}
			}
			.room-item {
				margin-bottom: 10px;
			}
			.room-name {
				margin-right: 20px;
			}
			.time {
				display:flex;
				.timerange {
					margin-right: 20px;
				}
			}
		}
		.detail-right {
			align-self: flex-end;
		}
		.buttons {
			display:flex;
			align-self: flex-end;
			.cancel,.again {
				margin-right: 20px;
			}
			.cancel,.again,.confirm,.detail {
				width:120px;
				padding:5px 0;
				color: #BD8BCA;
				@include fontSize($font-size-16);
				border:1px solid #BD8BCA;
				text-align: center;
				border-radius: 20px;
				cursor: pointer;
			}
		}
	}
}
.nodata {
	text-align: center;
	margin-top: 30px;
}
@media (max-width: 768px){
	.tips {
		margin:10px;
	}
	.container {
		padding-top: 2.4rem;
	}
	.searchbar {
		margin-top: 10px;
		margin-bottom: 20px;
		.datepicker {
			width:200px;
		}
		.division {
			margin:0 10px;
		}
		.button {
			margin-left: 10px;
		}
	}
	.order {
		.rooms {
			.room-item {
				display:flex;
				flex-direction: column;
			}
		}
		.order-detail {
			position:relative;
			flex-wrap: wrap;
			padding:10px;
			.detail-right {
				flex-direction: column;
				display:flex;
				align-items: center;
				width:100vw;
				margin-top: 10px;
				.buttons {
					align-self:center;
					justify-content: center;
				}
			}
		}
	}
}
.price {
	color:red;
	font-weight: 500;
}
.amount {
	color:red;
	font-weight: 500;
	font-size: 18px;
	// @include fontSize($font-size-20);
	margin-bottom: 10px;
}
.modal{
	margin: 10px 0;
	.title{
		margin: 10px 0;
		font-size: 18px;
		text-align: center;
	}
	.content{
		div{
			margin: 5px 10px;
		}
	}
}
.footer{
	display: flex;
	align-items: center;
	justify-content: flex-end;
	.cancel{
		color: grey;
		margin: 0 10px;
        cursor: pointer;
	}
	.confirm{
		color: white;
		margin: 0 10px;
		background: #BD8BCA;
		padding: 5px 15px;
		border-radius: 5px;
        cursor: pointer;
	}
}
.error{
    font-size: 12px;
    color: red;
}
</style>